import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { CardView } from 'design-system';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import { IconSquareCircle } from 'design-system/icons';
import { IconTwoUser } from 'design-system/icons/IconTwoUser';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
export const strings = {
    title: 'Turn on Contacts',
    androidReason: 'Emma transmits the contacts lists on your phone so you can easily make payments to your contacts using the Emma app.',
};
export const ContactsNoPermissions = ({ reasonMessage, enableActionTitle = 'Continue', enableAction, inverted = false, style, }) => {
    const colors = useColors();
    const colorStyle = inverted ? { White: true } : {};
    const colorStyleSubtitle = inverted
        ? { White: true }
        : { Gray: true };
    return (<CardView style={[styles.container, style]} noMarginTop>
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <IconSquareCircle color={colors.background.dark} width={64} height={64}>
            <IconTwoUser alt gradientKey="ultimate" width={32} height={32}/>
          </IconSquareCircle>
        </View>
        <Spacer h={16}/>
        <Text Text-16 centered {...colorStyle}>
          {strings.title}
        </Text>
        <Spacer h={4}/>
        <Text TextThin-14 centered Secondary {...colorStyleSubtitle}>
          {Platform.OS === 'android' ? strings.androidReason : reasonMessage}
        </Text>
        <Spacer h={16}/>
        <Button brandReversed small hug onPress={enableAction} title={enableActionTitle}/>
      </View>
      <View />
    </CardView>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        alignItems: 'center',
        paddingHorizontal: rem(16),
        paddingVertical: rem(24),
    },
    content: {
        alignSelf: 'center',
        justifyContent: 'center',
    },
    iconContainer: {
        alignSelf: 'center',
    },
});
